// Which license keys count in this copy of the web client — one rule for a license's signing key and for the
// key a revocation list is signed with (docs/features/licenses.md › Stage 2): live keys only, except on staging,
// a local worker and a quick tunnel to one, which take test-mode keys too. The built-in key list is the same
// everywhere; this is what keeps a test-mode key from meaning anything on the real site.
//
// One seam: `acceptedModes(hostname)` → ['live'] or ['live', 'test'].
const testHost = (host) => host === 'facecheck.codymccodeface.com' || host === 'localhost' || host === '127.0.0.1' || host === '[::1]' || host.endsWith('.localhost') || host.endsWith('.trycloudflare.com')

export function acceptedModes(hostname = globalThis.location?.hostname ?? '') {
  return testHost(String(hostname)) ? ['live', 'test'] : ['live']
}
